import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { CalculateRoadTaxRequestModel, RoadTaxAddEditModel, RoadTaxSettings } from "@model/road-tax.model";
import { QuotationRequestModel } from "@model/quotation.model";
import { GenericApiResponseModel, ResponseModel } from "@model/api.model";



@Injectable({
    providedIn: "root",
})
export class RoadTaxApiService {

    constructor(
        private http: HttpClient
        ) {
    }

    CalculateRoadTax(model: CalculateRoadTaxRequestModel): Observable<any> {
        return this.http.post<any>("/RoadTax/CalculateRoadTax",model);
    }

    VerifyVehicleInfo(model: QuotationRequestModel): Observable<any> {
        return this.http.post<any>("/RoadTax/VerifyVehicleInfo",model);
    }


    editRoadTaxCustomer(model: RoadTaxAddEditModel): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/RoadTax/customeredit', model
        );
    }

    createRoadTax(model: RoadTaxAddEditModel): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/RoadTax/create', model
        );
    }

    roadTaxSettings(): Observable<ResponseModel<RoadTaxSettings>> {
        return this.http.get<ResponseModel<RoadTaxSettings>>(
            '/RoadTax/roadTaxSettings/'
        );
    }

    UpdatePaymentLinkSentDateTime(id: string): Observable<any> {
        return this.http.post<any>("/RoadTax/UpdatePaymentLinkSentDateTime/"+id,'');
    }

}
